import { Theme } from 'config';

const styles = (theme: Theme) => ({
  header: {
    color: '#585858 !important',
    margin: '1.125rem 0 2.25rem 0 !important',
    fontSize: '1em !important',
  },
  container: {
    marginTop: '12.5rem',
  },
  form: {
    padding: '4rem',
    marginBottom: '4rem',
    background: '#fff',
    borderRadius: '0.25em',
    boxShadow:
      '0 0.0625em 0 0 rgba(0,0,0,0.03), 0 0.125em 0.375em 0 rgba(0,0,0,0.06);',
  },
  button: {
    backgroundColor: '#683caf !important',
    borderRadius: '1.5rem !important',
    color: '#fff !important',
    fontSize: '.875rem',
    margin: '.25rem 0 !important',
    opacity: 1,
    padding: '0.85em 4.150em !important',
    fontWeight: '500 !important',
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  '@global .ui.disabled.button ': {
    backgroundColor: '#d8dee1 !important',
    opacity: '1 !important',
  },

  spacing: {
    marginBottom: '3.350em !important',
  },
  formHeader: {
    marginRight: '1.5em !important',
    fontSize: '0.875em !important',
    color: '#646464 !important',
    fontWeight: '500 !important',
  },
  message: {
    marginBottom: '3em !important',
  },
  label: {
    verticalAlign: 'sub !important',
  },
  campaignStartContainer: {
    margin: '0 0 2rem -.5rem !important',
  },
  campaignStartLabel: {
    padding: '.5em !important',
    fontWeight: 500,
    whiteSpace: 'noWrap',
    color: '#683caf',
  },
  statSig: {
    padding: '.5em !important',
    color: `${theme.darkGray} !important`,
  },
  campaignStartDate: {
    padding: '.5em !important',
    whiteSpace: 'noWrap',
  },
  '@global .ui.card, .ui.cards > .card': {
    boxShadow: 'none',
  },
  reportButton: {
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    backgroundColor: '#fff !important',
    padding: '0 !important',
    height: '6.25rem !important',
    '@global .ui.checkbox': {
      backgroundColor: '#fff !important',
      width: '100% !important',
      borderRadius: '.25rem !important',
      padding: '1rem .625rem 1rem 1.25rem !important',
      border: '1px solid rgba(34,36,38,.15) !important',
    },
    '@global .ui.checkbox.checked': {
      backgroundColor: '#f7f8f9 !important',
      '@global label': {
        color: '#4a4a4a !important',
      },
    },
  },
  checkboxLabel: {
    display: 'flex !important',
    justifyContent: 'space-between !important',
    alignItems: 'center !important',
    height: '4.375rem !important',
    '&:before': {
      top: '36% !important;',
    },
    '&:after': {
      // clicked state
      top: '36% !important',
      backgroundColor: '#009bf6 !important',
      borderRadius: '.21428571rem !important',
      color: '#fff !important',
    },
  },
  labelImage: {
    pointerEvents: 'none !important',
    height: '5rem !important',

    '&.border': {
      border: '0.0625rem solid #DDD',
    },
  },
  typeLabel: {
    color: theme.violet,
    fontWeight: 500,
    fontSize: '.850rem',
  },
  textLabel: {
    marginTop: '.250rem',
  },
});

export default styles;
